import { utils, writeFile } from 'xlsx';

const CONSTITUTION_EXCEL_TEMPLATE_FILENAME = 'plantilla-constitucion-socios.xlsx';

const HEADERS = [
  'NOMBRE',
  'NRO ID',
  'NRO PPSS',
  'NRO PS INICIAL',
  'NRO PS FINAL',
  'CLASE',
  'PRIMA PS',
  'EMAIL',
  'TIPO ID',
  'NACIONALIDAD',
  'DIRECCION',
  'ESTADO CIVIL',
  'FECHA NACIMIENTO',
  'TIPO INVERSOR',
  'NRO EMPLEADO',
  'CUENTA BANCARIA',
  'RESIDENCIA FISCAL',
  'PERSONA JURIDICA',
];

const EXAMPLE_ROWS = [
  [
    'Ana García López',
    '12345678A',
    1000,
    '',
    '',
    'Ordinaria',
    0,
    'ana.garcia@example.com',
    'DNI',
    'España',
    'Calle Mayor 1, Madrid',
    'Soltera',
    '01/01/1980',
    'Inversor',
    '',
    '',
    '',
    'No',
  ],
  [
    'Inversiones Demo SL',
    'B12345678',
    500,
    '',
    '',
    'Ordinaria',
    1.5,
    'contacto@inversionesdemo.com',
    'CIF',
    'España',
    'Av. Diagonal 100, Barcelona',
    '',
    '',
    'Institucional',
    '',
    'ES1234567890123456789012',
    'Barcelona',
    'Si',
  ],
];

const INSTRUCTIONS_ROWS = [
  ['Instrucciones para rellenar la plantilla de Constitución'],
  [''],
  ['1. Complete la hoja "Socios" con un socio por fila.'],
  ['2. Los campos obligatorios son: NOMBRE, NRO ID y NRO PPSS.'],
  ['3. NRO PPSS indica el número de participaciones asignadas a cada socio.'],
  [
    '4. NRO PS INICIAL y NRO PS FINAL son opcionales. Si los rellena, se usarán esos rangos.',
  ],
  [
    '5. Si no indica rangos, las participaciones se numerarán automáticamente desde 1 por clase.',
  ],
  [
    '6. Si indica rangos y NRO PPSS, ambos deben coincidir (NRO PPSS = FINAL - INICIAL + 1).',
  ],
  ['7. CLASE debe coincidir con una clase de participaciones existente en la sociedad.'],
  ['8. Si no indica CLASE, se usará la clase ordinaria por defecto.'],
  ['9. La fecha y el valor nominal se indican en el modal de Constitución.'],
  [
    '10. Un mismo CIF puede repetirse en varias filas si los rangos de participaciones son distintos.',
  ],
];

export const downloadConstitutionExcelTemplate = (): void => {
  const workbook = utils.book_new();

  const partnersSheet = utils.aoa_to_sheet([HEADERS, ...EXAMPLE_ROWS]);
  utils.book_append_sheet(workbook, partnersSheet, 'Socios');

  const instructionsSheet = utils.aoa_to_sheet(INSTRUCTIONS_ROWS);
  utils.book_append_sheet(workbook, instructionsSheet, 'Instrucciones');

  writeFile(workbook, CONSTITUTION_EXCEL_TEMPLATE_FILENAME);
};
